import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { ApiService } from '../api.service';
import { AppComponent } from '../app.component';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';
import { ThumbnailService } from '../thumbnail.service';

@Component({
  selector: 'app-purchase-items-list',
  templateUrl: './purchase-items-list.component.html',
  styleUrls: ['./purchase-items-list.component.scss'],
})
export class PurchaseItemsListComponent  {

  loader:boolean = true;
  showQty;
  showDiv:boolean=false;
  showAdd:boolean=true;
  items = [];
  cartView:boolean=false;
  cartload: boolean = false;
  storeObj:any=[];
  filterData:any=[];
  itemTypeId;
  category;
  cateCode;
  search;
  name;
  purrchaseItems;
  delRegion;
  id;
  url;
Ind;
region;
orderId;
preOrderId;
orderItems: any =[];
itemtypeObj:any=[];
productName;
productId;
brandObj=[];
brandName;
brandId;
totalStoreObj:any=[];
amtLoader:boolean;
squareFeet:boolean=false;
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    private bottomSheet: MatBottomSheet, 
    public thumb:ThumbnailService,
    public auth: AuthService,
    public location: LocationService, 
    public app: AppComponent,
     public santinzer: DomSanitizer,
      public platform: Platform) { }

  ionViewWillEnter(){
    this.url=window.location.href;
    this.cartView=false;
    this.orderItems.orderAmountStr="";
    this.id=this.url.split('/').pop();
    this.preOrderId=sessionStorage.getItem('orderId')
    this.getById(); 
    this.getBrands();
    this.getProducts();
    this.getItems(); 
  }

  
  getBrands(){
    this.service.getAllbrand().subscribe((res:any) => {
      this.brandObj = res;
      Object.assign(this.brandObj,{highlight: false})
    })
  }

    getProducts(){
      this.loader=true;
      this.service.getAllProduct().subscribe((res:any)=>{
        if(res){
          this.itemtypeObj=res;
          this.itemtypeObj=this.itemtypeObj.filter(res=>{return res.purchaseCategory==this.id});
        }
      })
    }

openBottomSheet(){
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.itemtypeObj,
  });

  dialogRef.afterDismissed().subscribe((res:any) => {
    if (res) {
      this.productName = res.name;
      this.productId = res.id;
    }
  });
}

openBottomSheetBrand(){
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.itemtypeObj,
  });

  dialogRef.afterDismissed().subscribe((res:any) => {
    if (res) {
      this.brandName = res.name;
      this.brandId = res.id;
    }
  });
}


  getById(){
    this.loader=true;
    this.service.getOrderById(this.preOrderId).subscribe((res:any) => {
      if (res) {
        localStorage.setItem('shopId',res.orgId)
        this.purrchaseItems = res; 
        console.log(this.purrchaseItems)
        this.delRegion = res.delRegion;  
        this.itemTypeId = res.itemOrders[0].itemTypeId;        
      }
    },
      err => {
        this.handler.err(err.error)
      })
   
  }

  cancel(){
    if(this.url.includes('Vendor-Items')){
      this.router.navigate(['/vendor-Purchase-category'])
    }else{
      this.router.navigate(['/contractor-Purchase-category'])
    }
    
  }


  getItems(){ 
      this.service.getItemProductByCateId(this.id).subscribe((res:any)=>{
        if(res){
          this.storeObj = res;   
          this.storeObj.map(res1=>{
           Object.assign(res1, { select: false, qty: 0, showQty: 0,success:false}) 
          })
          this.totalStoreObj = this.storeObj;
          this.loader=false;  
          
        }else{
          this.loader=false;
          this.storeObj=[];
          this.totalStoreObj=[];
        }
         
     },err =>{
       this.handler.err(err)
       this.loader = false;    
     }) 
}


  addQuantity(data) { 
    this.showDiv=false;  
    this.storeObj.map(res => {
      if (res != data)
        res.select = false;
      else
        res.select = true
    })      
      data.showQty = data.showQty + 1;
      if(data.showQty > 0){
        this.cartView = true;
      }
    if(!this.orderId){       
      this.createOrder(); 
    } else{
      this.updateOrder();
    }      

}

  decQuantity(data) { 
    this.showDiv=false;  
    this.storeObj.map(res => {
      if (res != data)
        res.select = false;
      else
        res.select = true
    })
       if (data.showQty == 0)
        data.showQty = data.showQty;
      else {
        data.showQty = data.showQty - 1;
        this.updateOrderItem()
      }
  }
  createOrder() {
    this.cartload = true;
    this.showAdd = false;
    let item = this.storeObj.find(res => res.showQty != 0 && res.select);
  
    item.qty = 1;
    let postData = { 
      "customerId":this.purrchaseItems.customerId,
      "orgId":this.purrchaseItems.orgId,  
      "categoryId":this.id, 
      "delDoorNbr": this.purrchaseItems.delDoorNbr,
      "delStreet": this.purrchaseItems.delStreet,
      "delCity": this.purrchaseItems.delCity,
      "delState":this.purrchaseItems.delState,
      "region":this.purrchaseItems.region,
      "delRegion":this.purrchaseItems.delRegion,
      "itemTypeId":this.itemTypeId,
      "vendorId":this.purrchaseItems.vendorId,
      "serviceContractorId":this.purrchaseItems.serviceContractorId,
      "appt":this.purrchaseItems.appt,
      "capacityDefId":  '1',
      "custName"  :this.purrchaseItems.custName,
      "apptTime": this.purrchaseItems.apptTime,
      "apptDate": this.purrchaseItems.apptDate,
      "apptStartTime":this.purrchaseItems.apptStartTime,   
      "apptEndTime":  this.purrchaseItems.apptEndTime,
      "requestDates": [
        {
            "apptDate": this.purrchaseItems.apptDate,
            "apptTime":  this.purrchaseItems.apptTime,  
            "apptEndTime":  this.purrchaseItems.apptEndTime ,         
            "status": 1
        }],     
      "status": 10,
      "paymtStatus": 1,
      "paymtMode": 1,
      "orderType" : 2,
      "items" :[
          {
              "id" : item.id,
              "qty": item.qty,
              "productId":item.productId
          }
      ],     
    }
    if(!this.purrchaseItems.appt){
      Object.assign(this.orderItems,{"delDoorNbr":this.purrchaseItems.delDoorNbr,"delStreet": this.purrchaseItems.street})
    }else{
      Object.assign(this.orderItems,{"flatNo":this.purrchaseItems.flatNo, "flatName":this.purrchaseItems.flatName,})
    }
    this.service.placeOrder(postData).subscribe((res: any) => {
      if(res){
        this.orderId = res.id;
        this.cartload = false;
        this.orderItems = res;        
        if (this.orderItems.items) {
          this.storeObj.map(dat => {
            this.orderItems.storeObj.map(dat1 => {
              if (dat.id == dat1.id)
                dat.showQty = dat1.qty;
            })
          })
        }
        // this.getOrder(this.orderId);
        this.showDiv=true;
        this.showAdd=true;
      }
   
    },
      err => {
        this.handler.err(err);
            this.cartload = false;  
      })
  }

  updateOrder() {  
    this.showAdd=false;
    let item;
    item = this.storeObj.find(dat => dat.showQty != -1 && dat.select);      
      item.qty = 1;
    let products = {      
      "items" :[
        {
            "id" : item.id,
            "qty" :item.qty,
            "productId":item.productId
        }
    ],
orderType: 2,
     }
    this.cartload = true;
    this.service.orderItemPost(this.orderId, item.id, products).subscribe((res:any) => {
      if(res){
        // this.getOrder(this.orderId);
        this.cartload = false;
        this.orderItems = res;        
        if (this.orderItems.items) {
          this.items.map(dat => {
            this.orderItems.items.map(dat1 => {
              if (dat.id == dat1.id)
                dat.showQty = dat1.qty;
            })
          })
        }
        this.showDiv=true;
        this.showAdd=true;
      }

    },
      err => {
        this.cartload = false;
              this.handler.err(err)
      })
  }

  async updateOrderItem(){
    let item;
    item = this.storeObj.find(dat => dat.showQty != -1 && dat.select);
    item.qty = item.showQty;
    let products = {      
      "items" :[
        {
            "id" : item.id,
            "qty" :item.qty,
            "productId":item.productId
        }
    ],
      orderType: 2 }  
      this.cartload=true;
      this.service.updateOrderItem(this.orderId, item.id, products).subscribe(res => {
        if(res){
          this.cartload = false;
          this.showDiv=true;
          this.showAdd=true;
          this.orderItems = res;          
          if (this.orderItems.items) {
            this.items.map(dat => {
              this.orderItems.items.map(dat1 => {
                if (dat.id == dat1.id)
                  dat.showQty = dat1.qty;
              })
            })
          }
        }
        // this.getOrder(this.orderId);
       
      },
        err => {
          this.cartload = false;
               this.handler.err(err)
        })
    }

    PlaceOrder(){ 
       this.loader=true;  
          var post={
            orderType:2
          }
          this.service.completeOrder(this.orderId,post).subscribe(res => {
            this.handler.res("Items Added SuccessFully");    
            this.router.navigate(['/vendor-request'])
            this.loader=false; 
          },
            err => {  
              this.loader=false; 
              this.handler.err(err);     
            })
           }
}

